import React, { Component } from 'react';
import $ from 'jquery';
import { Link,browserHistory } from 'react-router';
import {Breadcrumb} from 'react-bootstrap';
import WebHeaderInner from '../Common/WebHeaderInner.js';
import WebFooter from '../Common/WebFooter.js';
import PDeal from './modules/pdeals_list.js';
import InfiniteScroll from 'react-infinite-scroll-component';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

// "/web/pdeals/:BrandName/:CatName/:Tid/:Type/:DType";
// "/web/pdeals/:BrandName/:Type/:DType";
// "/web/pdeals/brands/:BrandName/:Bid";


export default class Web_ProductDetails extends Component {
    constructor(props){
    super(props);
    this.state={
      feedsList: [],
      fulldata:[],
      feedbrands: [],
      feed_sub_cat:[],
      feedcat: [],
      todata:'',
      nodata:false,
      open: false,
      types:[],
      title:'',
      desc:'',
      tid : this.props.params.Tid,
      type: this.props.params.Type,
      dtype: this.props.params.DType,
      htype: this.props.params.DType,
      data_type: this.props.params.DType,
      bread: '',
      activeMenu: '',
      selected: '',
      loading: false,
      lod: false,
      loadmore_number: 2,
      loadmore_status: 0,
      set_type:'',
      next_page:'',
      seo_desc:'',
      loading_gif:false,
      h1_desc:'',
      nodata_status:false,
      cart_count:0,

      bid:this.props.params.Bid,
      brandname:this.props.params.BrandName,
      location:this.props.location.pathname,
      route:'/web/pdeals/brands/'+this.props.params.BrandName+'/'+this.props.params.Bid,
      
      brands_status:false,
      cat_status:false,
      sortList:[],
      total_deals:'',

      categories:[],
      catloading_gif:false,
    
    };
    localStorage.setItem('d_type',this.props.params.DType);
    // localStorage.setItem('Tid',this.props.params.Tid);
    localStorage.setItem('h_type',this.props.params.DType);
    localStorage.setItem('type',this.props.params.Type);
    this.test=this.test.bind(this);  
    this.test1=this.test1.bind(this);
    this.getTypes=this.getTypes.bind(this);
    // this.loadMoreDeals=this.loadMoreDeals.bind(this);
    this.getDeviceId=this.getDeviceId.bind(this); 
    this.fetchData=this.fetchData.bind(this);
    this.refresh=this.refresh.bind(this);
    this.getCartCount=this.getCartCount.bind(this);

    this.getBrandCat =this.getBrandCat.bind(this);
    this.getSelectedCatSort=this.getSelectedCatSort.bind(this);
    this.getBrand_Categories=this.getBrand_Categories.bind(this);
    this.get_product_list =this.get_product_list.bind(this); 
  }
  getBrandCat()
  {
    if(this.props.params.Type)
    {
       var type = this.props.params.Type;
    }
    else
    {
       type ='brand';
    }
    if(this.props.params.Bid)
    {
      var tid = this.props.params.Bid;
    }
    else
    {
       tid = this.state.tid;
    }
    if(this.props.params.DType)
    {
       var dtype = this.props.params.DType;
    }
    else
    {
       dtype =0;
    }
    var data1 = {from:'desktop_web',type:type,tid:tid,dtype:dtype};
    var data2 = JSON.stringify(data1);
    $.ajax({
       url:baseUrl+'filterBrandCat',
       method:'POST',
       dataType:'json',
       data:{req:data2},
       success:function(data)
       {
          if(data.status === 'success')
          {
              this.setState({
                brands:data.brands_lst,
                categories:data.cat_lst,
                sortList:data.sort});
          }
       }.bind(this),
       error:function(err)
       {
       }
    });
  }
  getBrand_Categories()
  {
        if(this.props.params.Bid)
        {
          var type=0;
          var bid=this.props.params.Bid;
        }
        else
        {
          type=this.props.params.DType;
          bid='';
        }
        this.setState({catloading_gif:true});
        var data1={from: 'desktop_web',type:type,bid:bid};
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getbrands_categoires',
            dataType:'json',
            data: {req:data2},
            success: function(data){
            this.setState({
                fulldata: data,
                feedbrands:data.brands,
                feedcat:data.categories,
                dtype: this.props.params.DType,
                bread: data.cat_name,
                loading: true,
                // total_deals:data.tot_deals,
                // selected:data.cat_name,
                catloading_gif:false,
            });
         }.bind(this),
        error: function(err){
        // console.log("Error"+err);

        }
        })
  }
  getSelectedCatSort(event)
  {

      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index];
      var id =  optionElement.getAttribute('id');
      // var num=this.state.next_page;
      // var name = event.target.value;
      this.setState({
          loading_gif:true,
          // sortid:id,
      });
      localStorage.setItem('web_cat_sort',id);

      if(localStorage.user_id)
      {
        var  uid=localStorage.getItem('user_id')
      }
      else
      {
         uid=0;
      }
       if(this.props.params.DType)
       {
         var dtype = this.props.params.DType;
       }
       else
       {
          dtype =0;
       }

      // if(this.state.type === 'offers')
      // {
      //   var data1={from:'desktop_web',"tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":id}
      //   var getfunc ='getProductbycat_brand';
      // }
      // else if(this.props.params.Bid)
      // {
      //    data1={from:'desktop_web',uid:uid,type:'brand',dtype:dtype,tid:this.props.params.Bid,sort:id};
      //     getfunc ='getProductbycat_brand';
      // }
      // else if(this.state.type === 'all')
      // {
      //     data1={from:'desktop_web',uid:uid,type:this.state.dtype,sort:id,limit:20};
      //      getfunc ='getPoductDeals';
      // }
      // else {
      //    data1={from: 'desktop_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype,sort:id};
      //    getfunc ='getProductbycat_brand';
      // }
          var type=this.state.set_type;
          // var dtype=this.props.params.DType;
          var tid=this.props.params.Tid;
          // if(this.state.sortid)
          // {
          //   var sortid=this.state.sortid;
          // } 
          // else
          // {
          //   sortid=1;
          // }
          var getfunc="";
          var data1="";
          var data2="";
          
          type =this.props.params.Type;
          if(type==="all")
          {
            data1={from :'desktop_web',uid:uid,type:dtype,limit:20,sort:id};
            data2=JSON.stringify(data1);
            getfunc="getPoductDeals";
          }
          else if(type==="Pcategory")
          {
            data1={from: 'desktop_web',uid:uid, dtype:dtype, type:type,tid:tid,limit:20,sort:id};
            data2=JSON.stringify(data1);
            getfunc="getProductbycat_brand";
          }
          else if(type==="brand")
          {
            data1={from:'desktop_web',uid:uid,dtype:dtype,type:type,tid:tid,limit:20,sort:id};
            data2=JSON.stringify(data1);
            getfunc="getProductbycat_brand";
          }
          else if(type==="partner")
          {
            data1={from:'desktop_web',uid:uid,dtype:0,type:type,tid:tid,limit:20,sort:id};
            data2=JSON.stringify(data1);
            getfunc="getProductbycat_brand";  
          }
          else if(this.props.params.Bid)
          {
              data1={from:'desktop_web',uid:uid,dtype:0,type:'brand',tid:this.props.params.Bid,limit:20,sort:id};
              data2=JSON.stringify(data1);
              getfunc="getProductbycat_brand";
          }
       // var data2 =JSON.stringify(data1);
       $.ajax({
          url:baseUrl+getfunc,
          method:'POST',
          dataType:'JSON',
          data:{req:data2},
          success:function(data)
          {
             if(data.status === 'success')
             {
                if(data.result.length === 0)
                {
                   this.setState({loading_gif:false});
                }
                 
                this.setState({
                  feedsList:data.result,
                  offer: data,
                  todata: data,
                  loading:true,
                  title: data.product_name,
                  desc:'The best offers of AquaDeals',
                  selected  : data.cat_name,
                  loadmore_status:data.load_more,
                  set_type:data.set_type,
                  next_page:data.next_page,
                  loading_gif:false,
                  total_deals:data.tot_deals,

                });
             }
          }.bind(this),
          error:function(err)
          {

          }
       });
  }

  getCartCount()
  {
      if(localStorage.user_id)
      {
        var uid=localStorage.getItem('user_id');
      }
      else
      {
        uid=0;
      }
      var data1={from: 'desktop_web',id:uid,token:localStorage.getItem('token')};
      var data2=JSON.stringify(data1);
      $.ajax({
            method: 'POST',
            url: baseUrl+'cart_count',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
                this.setState({
                    cart_count:data.cart_count,
                });
            }.bind(this),
            error: function(err)
            {
            }
      });
  }
  fetchData()
  {
      // this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
      var num=this.state.next_page;
      var type=this.state.set_type;
      var dtype=this.props.params.DType;
      var tid=this.props.params.Tid;
      // if(this.state.sortid)
      // {
      //   var sortid=this.state.sortid;
      // } 
      // else
      // {
      //   sortid=1;
      // }
      
      if(localStorage.user_id)
      {
         var  uid=localStorage.getItem('user_id')
      }
      else
      {
         uid=0;
      }
      if(this.props.params.DType)
      {
        dtype = this.props.params.DType;
      }
      else
      {
         dtype =0;
      }
      
      var getfunc="";
      var data1="";
      var data2="";
      type =this.props.params.Type;
      if(type==="all")
      {
        data1={from :'desktop_web',uid:uid,page:num,type:dtype,limit:20};
        data2=JSON.stringify(data1);
        getfunc="getPoductDeals";
      }
      else if(type==="Pcategory")
      {
        data1={from: 'desktop_web',uid:uid,page:num, dtype:dtype, type:type,tid:tid,limit:20};
        data2=JSON.stringify(data1);
        getfunc="getProductbycat_brand";
      }
      else if(type==="brand")
      {
        data1={from:'desktop_web',uid:uid,page:num,dtype:dtype,type:type,tid:tid,limit:20};
        data2=JSON.stringify(data1);
        getfunc="getProductbycat_brand";
      }
      else if(type==="partner")
      {
        data1={from:'desktop_web',uid:uid,page:num,dtype:0,type:type,tid:tid,limit:20};
        data2=JSON.stringify(data1);
        getfunc="getProductbycat_brand";  
      }
      else if(this.props.params.Bid)
      {
          data1={from:'desktop_web',uid:uid,page:num,dtype:0,type:'brand',tid:this.props.params.Bid,limit:20};
          data2=JSON.stringify(data1);
          getfunc="getProductbycat_brand";
      }
      if(this.state.loadmore_status===1)
      {
            this.setState({
              loading_gif:true,
            })
              $.ajax({
                  method:'POST',
                  dataType:'json',
                  data:{req:data2},
                  url:baseUrl+getfunc,
                  success:function(data)
                  {
                      if(data.products)
                      {
                          if(data.load_more===1)
                          {
                            this.setState({
                                feedsList:this.state.feedsList.concat(data.products),
                                offer: data,
                                todata: data,
                                loadmore_status:data.load_more,
                                set_type:data.set_type,
                                next_page:data.next_page,
                                loading_gif:false,
                                selected:data.cat_name,
                            });
                          }
                          else
                          {
                              this.setState({
                                feedsList:this.state.feedsList.concat(data.products),
                                  set_type:data.set_type,
                                  next_page:data.next_page,
                                  loadmore_status:data.load_more,
                                  loading_gif:false,
                                  selected:data.cat_name,
                              });
                          }
                      }
                      else
                      {
                        if(data.load_more===1)
                        {
                              this.setState({
                                  feedsList: this.state.feedsList.concat(data.result),
                                  set_type:data.set_type,
                                  next_page:data.next_page,
                                  loadmore_status:data.load_more,
                                  loading_gif:false,
                                  selected:data.cat_name,
                              });
                          } 
                          else
                          {
                              this.setState({
                                  feedsList: this.state.feedsList.concat(data.result),
                                  set_type:data.set_type,
                                  next_page:data.next_page,
                                  loadmore_status:data.load_more,
                                  loading_gif:false,
                                  selected:data.cat_name,
                              });

                          }

                      }
                    }.bind(this),
                  error:function(err)
                  {
                      this.setState({
                        loading_gif:false,
                      })
                 }.bind(this)
        });
      }
  }
  refresh()
  {
    console.log("");
  }
  getDeviceId()
  {
      if(localStorage.user_id)
      {
          var user_id=localStorage.user_id;
      }
      else
      {
        user_id=0;
      }
      var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getDeviceId',
          dataType: 'json',
          data:{req: data2},
          success: function(data){
            
          },
          error: function(err){
          }
      });
  }
  getTypes()
  {   
      var data1={from: 'desktop_web'};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getTypes',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                  types:data.types,
              });
              }.bind(this),
          error: function(err){
               // console.log("Error"+err);
          }
      })
  }
  
  componentDidMount()
  { 
      window.scrollTo(0, 0);        
      var uid =0;
      if(localStorage.user_id)
      {
         uid=localStorage.getItem('user_id')
      }
      else
      {
         uid=0;
      }
    
      // this.setFilter(this.state.bid); 
     
      this.getCartCount();
      
      localStorage.removeItem('w_r_s_dt');
      localStorage.removeItem('w_r_e_coupon_dt');
      localStorage.removeItem('w_r_e_s_dt');
      localStorage.removeItem('web_mycart');
      localStorage.removeItem('w_r_enq_seller_page');
      localStorage.removeItem('w_r_p_dt');
      localStorage.removeItem('w_r_e_p_dt');
      localStorage.removeItem('web_ofr_page');
      localStorage.removeItem('profile');
      localStorage.removeItem('myaquacash');
      localStorage.removeItem('web_share_earn');
      localStorage.removeItem('checkout');
      localStorage.removeItem('order_details');
      localStorage.removeItem('myorders');
      
      localStorage.removeItem('seed');
      localStorage.removeItem('nauplii');
      localStorage.removeItem('subdeals');
      localStorage.removeItem('shipping');
      localStorage.removeItem('notifications');
      localStorage.removeItem('web_quickcart');
      localStorage.removeItem('view_rating');
      localStorage.removeItem('w_modal_seed');
      localStorage.removeItem('w_r_seed_deals');
      localStorage.removeItem('w_r_e_p_dt');
      localStorage.removeItem('w_modal_details');
      localStorage.removeItem('offers');
      localStorage.removeItem('give_rating');
      localStorage.removeItem('pprice');
      localStorage.removeItem('sprice');
      localStorage.removeItem('seed_id');
      localStorage.removeItem('h_type');
      localStorage.removeItem('web_pro_ofr_dtls');
      localStorage.removeItem('web_wishlist');
      localStorage.removeItem('web_brand_details');

      localStorage.removeItem('m_r_s_dt');
      localStorage.removeItem('m_r_e_coupon_dt');
      localStorage.removeItem('m_r_e_s_dt');
      localStorage.removeItem('mob_mycart');
      localStorage.removeItem('m_r_enq_seller_page');
      localStorage.removeItem('m_r_p_dt');
      localStorage.removeItem('m_r_e_p_dt');
      localStorage.removeItem('ofr_page');
      localStorage.removeItem('pro_ofr_dtls');

      localStorage.removeItem('share_earn');
      localStorage.removeItem('my_orders');
      localStorage.removeItem('m_r_p_deals');
      localStorage.removeItem('mob_quickcart');
      localStorage.removeItem('partner_deals');
      
      this.getDeviceId();
      this.getBrandCat();

      if(this.props.params.Type==="all" && screen.width < 800)
      {
        window.location.href="/pdeals/"+this.props.params.BrandName+"/all/"+this.props.params.DType;
      }
      if(this.props.params.CatName && this.props.params.Tid)
      {
          localStorage.setItem('w_r_p_deals',"/web/pdeals/"+this.props.params.BrandName+"/"+ this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType);  
      }
      if(screen.width <=800 && window.location.hash==="/pdeals/feed/offers/35/>=/4")
      {
        window.location.href="/offers_details/35/>=/4";
      }
      else if(screen.width <= 800 && this.props.params.CatName && this.props.params.Tid)
      {
          localStorage.setItem('w_r_p_deals',"/web/pdeals/"+this.props.params.BrandName+"/"+ this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType);  
          window.location.href="/pdeals/"+this.props.params.BrandName+"/"+ this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType;
      }
      
      if(!this.props.params.CatName && this.props.params.Type )
      {
        localStorage.setItem('w_r_p_deals',"web/pdeals/"+this.props.params.BrandName+"/"+this.props.params.Type+"/"+this.props.params.DType);
      }
      
      if((this.props.params.BrandName  && this.props.params.Bid) && screen.width < 800)
      {
        window.location.href = "/pdeals/brand/"+this.props.params.BrandName+"/"+this.props.params.Bid;
      }

       $(window).scrollTop(0);
        var self = this;
        setTimeout(() => {self.setState({lod: true}); }, 15000);

        localStorage.setItem('h_type',this.props.params.DType);
        localStorage.setItem('d_type',this.props.params.DType);
          this.getTypes();

           // if(this.props.params.DType)
           // {
           //  var dtype =this.props.params.DType;
           // }
           // else
           // {
           //    dtype = 0;
           // }
   
          // if(this.props.params.DType)
          // {
          //   var dtype =this.props.params.DType;
          // }
          // else if(this.props.params.Type)
          // {
          //     dtype = this.props.params.Type;
          // }
          // else
          // {
          //    dtype ='brand';
          // }
          // if(!this.props.params.Tid && !this.props.params.DType && !this.props.params.Type)
          // {
          //    dtype = 'brand';
          // }

          // if(this.props.params.Bid)
          // {
          //   var tid = this.props.params.Bid;
          // }
          // else
          // {
          //    var tid = this.state.tid;
          // }
         
         this.getBrand_Categories();
          var data1= "";
          var data2= "";
          var get_function = "";
          if(this.state.type === '>=')
          {
             data1={from: 'desktop_web',uid:uid,discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type,limit:20};
              data2=JSON.stringify(data1);
              get_function = 'getNewsearch';
              this.get_product_list(data2,baseUrl,get_function);  
          }
          else if(this.state.type==='sub'){
              data1={from: 'desktop_web',uid:uid,pid: this.state.tid, limit:20};
              data2=JSON.stringify(data1);
              get_function = 'getNewsearch';
              this.get_product_list(data2,baseUrl,get_function);  
          }
          else if(this.state.type==='all'){
              data1={from: 'desktop_web',type:this.state.dtype,limit:20};
              data2=JSON.stringify(data1);
              get_function='getPoductDeals';
              this.get_product_list(data2,baseUrl,get_function);  
          }
          else if(this.state.type==='offers'){
              data1={from: 'desktop_web',uid:uid,deal_offer_type: this.state.dtype,type: '',limit:20};
              data2=JSON.stringify(data1);
              get_function='getProductbycat_brand';                        
              this.get_product_list(data2,baseUrl,get_function);
          }
          else if(this.state.type==='Pcategory')
          {
              data1={from: 'desktop_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:this.state.dtype,deal_ids:this.props.params.Dids};
              data2=JSON.stringify(data1);
              get_function='getProductbycat_brand';
              this.get_product_list(data2,baseUrl,get_function);  
          }
          else if(this.state.type==='brand')
          {
              data1={from:'desktop_web',uid:uid,type:this.state.type, tid:this.state.tid,dtype:this.state.dtype};
              data2=JSON.stringify(data1);
              get_function='getProductbycat_brand';
              this.get_product_list(data2,baseUrl,get_function);
          }
          else if(this.props.params.Bid)
          {
              data1={from:'desktop_web',uid:uid,type:'brand',tid:this.props.params.Bid};
              data2=JSON.stringify(data1);
              get_function='getProductbycat_brand';
              this.get_product_list(data2,baseUrl,get_function);
          }
          // else
          // { 
          //     data3={from: 'desktop_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:dtypethis.state.dtype,limit:20};
          //     data4=JSON.stringify(data3);
          //     get_function = 'getProductbycat_brand';          
          // }
  }

  get_product_list(data2,baseUrl,get_function)
  {
     $.ajax({
        method: 'POST',
        url: baseUrl+get_function,
        dataType:'json',
        data: {req:data2},
        success: function(data){
        if(data.products)
        {
            this.setState({
                feedsList:data.products,
                offer: data,
                todata: data,
                loading:true,
                title: data.product_name,
                desc:'The best offers of AquaDeals',
                selected  : data.cat_name,
                loadmore_status:data.load_more,
                set_type:data.set_type,
                next_page:data.next_page,
                loading_gif:false,
                total_deals:data.tot_deals,
            });
                // document.getElementById('cat_4').addClass("active");
        }
        else
        {
            this.setState({
                feedsList:data.result,
                offer: data,
                todata: data,
                loading:true,
                title:data.cat_name,
                desc:'Browse best deals,Aquaculture products from '+data.cat_name +' in AquaDeals.Contact customer care for any queries.',
                selected  : data.cat_name,
                loadmore_status:data.load_more,
                set_type:data.set_type,
                next_page:data.next_page,
                seo_desc:'',
                loading_gif:false,
                total_deals:data.tot_deals,
            });
        }
        if(data.status==='error')
        {
            this.setState({
              loading_gif:false,
              nodata_status:true,
            });
            if(this.props.params.DType==="2" && this.props.params.Type !=='all')
            {
              var nodata_red_url='/web/pdeals/feed/all/2';
            }
            else if(this.props.params.DType==="4" && this.props.params.Type !=='all')
            {
                nodata_red_url='/web/pdeals/health-care/all/4';
            }
            else if(this.props.params.DType==="3" && this.props.params.Type !=='all')
            {
                nodata_red_url='/web/pdeals/machine-equip/all/3'
            }
            else if(this.props.params.DType==="5" && this.props.params.Type !=='all')
            {
                nodata_red_url='/web/pdeals/hatchery-machinery/all/5';
            }
            else if(this.props.params.DType==="7" && this.props.params.Type !=='all')
            {
                nodata_red_url='/web/pdeals/hatchery-health-care/all/7';
            }
            else
            {
                nodata_red_url='/web/home';
            }
        }
        if(this.props.params.Type === "Pcategory")
        {
            this.setState({
              h1_desc: 'Shop best deals on '+data.cat_name+' products',
            })
        }
        else if(this.props.params.Type === 'brand')
        {
            this.setState({
              h1_desc: 'Shop best deals on '+data.cat_name+' products',
            })
        }
        else if(this.props.params.Type==="all")
        {
            this.setState({
              h1_desc: 'Shop best deals on '+data.cat_name+' products',
            })
        }
        else if(this.props.params.Bid)
        {
          this.setState({
            h1_desc:'Shop best deals on '+data.cat_name+' products',
          })
        }

      if(this.props.params.Type==="all")
      {
          if(this.props.params.DType==="2")
          {
                document.title="Buy Aqua Feed Products Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          }
          else if(this.props.params.DType==="4")
          {
              document.title="Buy Aqua Healthcare Products Online | AquaDeals"; 
              document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          }
          else if(this.props.params.DType==="3")
          {   document.title="Buy Aqua Machinery & Equipment Products Online | AquaDeals";
              document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Machinery & Equipment deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          }
          else if(this.props.params.DType==="5")
          {   document.title="Buy Aqua Hatchery Machinery Products Online | AquaDeals";
              document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          }
          else if(this.props.params.DType==="7")
          {  
              document.title="Buy Aqua Hatchery Health Care Product deals Online | AquaDeals";
              document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          }
          else {
           document.title="Buy Aquaculture deals Online | AquaDeals";
           document.getElementsByTagName("META")[2].content="Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          }
      }
      if(this.props.params.Type === "Pcategory")
      {
            // document.title =this.state.title + " - Products | AquaDeals ";
            // document.getElementsByTagName("META")[2].content="Browse bestÂ deals,Aquaculture products from various brandsÂ in "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
            if(this.props.params.BrandName==="feed")
            {
                document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
            } 
            else if(this.props.params.BrandName==="health-care")
            {
                document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
            }
            else if(this.props.params.BrandName==="aerators")
            {
                document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' products from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
            }
            else
            {
                document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
            }
       }
       else if(this.props.params.Type === 'brand')
       {
            // document.title =this.state.title + " - Products | AquaDeals ";
            // document.getElementsByTagName("META")[2].content="Browse best deals, AquacultureÂ products from "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
            if(this.props.params.BrandName==="feed")
            {
                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.BrandName==="health-care")
            {
                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.BrandName==="aerators")
            {
                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
            }
            else
            {
                document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture Fish / Vannamei Shrimp " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
            }
        }
        else if(this.props.params.Bid)
        {
            document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
            document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture deals, choose the best deal price from our nearest partner and avail free shipment";
        }

      
        }.bind(this),
        error: function(err){
        }
        });
  }
  // test(type,tid,page)
  test(type,tid,dtype)
  { 
        this.setState({
            loading_gif:true,
        });
        var uid =0;
        if(localStorage.user_id)
        {
           uid=localStorage.getItem('user_id')
        }
        else
        {
           uid=0;
        }
        // if(this.props.params.DType)
        // {
        //   var dtype =this.props.params.DType;
        // }

        // else
        // {
        //    dtype =0;
        // }
         // console.log(typeof('type'));
        if(type !== undefined)
        {
           var type= type;
        }
        else
        {
           type = 'brand';
        }

        if(tid)
        {
         var tid =tid;
        }
        else
        {
           tid = this.state.bid;
        }
        
        localStorage.setItem('w_r_p_deals',"/web/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType)
        $(window).scrollTop(0);
        // var data1={from: 'desktop_web',uid:uid,dtype:dtype/*this.state.data_type*/,type:type,tid:tid,limit:20};
        var data1={from: 'desktop_web',uid:uid,dtype:dtype,type:type,tid:tid,limit:20};
        localStorage.setItem('Tid',tid);
        localStorage.setItem('type',type);
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getProductbycat_brand',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
                this.setState({
                    feedsList:data.result,
                    offer: data,
                    loading:true,
                    bread: data.cat_name,
                    title:data.cat_name,
                    desc:data.cat_desc,
                    loadmore_status: data.load_more,
                    set_type:data.set_type,
                    next_page:data.next_page,
                    seo_desc:'Browse best deals,Aquaculture products from various brands in '+data.cat_name+'. Contact customer care for any queries.',
                    loading_gif:false,
                    nodata_status:false,
                    selected:data.cat_name,
                    total_deals:data.tot_deals,
                });
                if(data.status==='error')
                {
                  this.setState({
                    nodata_status:true,
                  })
                }
                if(this.props.params.Type === "Pcategory")
                {
                  this.setState({
                    h1_desc: 'Shop best deals on '+data.cat_name+' products',
                  })
                }
                else if(this.props.params.Type === 'brand')
                {
                  this.setState({
                    h1_desc: 'Shop best deals on '+data.cat_name+' products',
                  })
                }
                else if(this.props.params.Bid)
                {
                  this.setState({
                    h1_desc: 'Shop best deals on '+data.cat_name+' products',
                  }) 
                }
                 if(this.props.params.Type==="all")
        {
            if(this.props.params.DType==="2")
            {
                  document.title="Buy Aqua Feed Products Online | AquaDeals";
                  document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.DType==="4")
            {
                document.title="Buy Aqua Healthcare Products Online | AquaDeals"; 
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.DType==="3")
            {   document.title="Buy Aqua Machinery & Equipment Products Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Machinery & Equipment deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.DType==="5")
            {   document.title="Buy Aqua Hatchery Machinery Products Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else if(this.props.params.DType==="7")
            {  
                document.title="Buy Aqua Hatchery Health Care Product deals Online | AquaDeals";
                document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
            else {
             document.title="Buy Aquaculture deals Online | AquaDeals";
             document.getElementsByTagName("META")[2].content="Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
            }
          // if(this.props.params.BrandName==="feed")
          // {
          //   document.title="Buy Aqua "+data.cat_name+" Products Online | AquaDeals";
          //   document.getElementsByTagName("META")[2].content="Browse quality Aquaculture "+ data.cat_name +" deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";    
          // }
          // else if(this.props.params.BrandName==="health-care")
          // {
          //  document.title="Buy Aqua Healthcare Products Online | AquaDeals"; 
          //  document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          // }
          // else if(this.props.params.BrandName==="machine-equip")
          // {
          //   document.title="Buy Aqua Machine & Equipment Products Online | AquaDeals";
          //   document.getElementsByTagName("META")[2].content="Browse quality Aquaculture "+data.cat_name+" deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          // }
          // else if(this.props.params.BrandName==="hatchery-machinery")
          // {
          //   document.title="Buy Aqua Hatchery Machiney Products Online | AquaDeals";
          //   document.getElementsByTagName("META")[2].content="Browse quality Aquaculture "+data.cat_name+" deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
          // }
          // else
          // {
          //     document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
          //     document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
          // }
        }
        if(this.props.params.Type === "Pcategory")
        {
              // document.title =this.state.title + " - Products | AquaDeals ";
              // document.getElementsByTagName("META")[2].content="Browse bestÂ deals,Aquaculture products from various brandsÂ in "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
              if(this.props.params.BrandName==="feed")
              {
                  document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
              } 
              else if(this.props.params.BrandName==="health-care")
              {
                  document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
              }
              else if(this.props.params.BrandName==="aerators")
              {
                  document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' products from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
              }
              else
              {
                  document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
              }
         }
         else if(this.props.params.Type === 'brand')
         {
              // document.title =this.state.title + " - Products | AquaDeals ";
              // document.getElementsByTagName("META")[2].content="Browse best deals, AquacultureÂ products from "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
              if(this.props.params.BrandName==="feed")
              {
                  document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
              }
              else if(this.props.params.BrandName==="health-care")
              {
                  document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
              }
              else if(this.props.params.BrandName==="aerators")
              {
                  document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
              }
              else
              {
                  document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
                  document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture Fish / Vannamei Shrimp " +data.dtype_name+" deals, choose the best deal price from our nearest partner and avail free shipment";
              }
          }
          else if(this.props.params.Bid)
        {
            document.title='Buy '+data.cat_name+' Aqua Products Online | AquaDeals';
            document.getElementsByTagName("META")[2].content="Search "+data.cat_name+" branded quality Aquaculture deals, choose the best deal price from our nearest partner and avail free shipment";
        }


            }.bind(this),
            error: function(err)
            {
               // console.log("Error"+err);
            }
        });
  }
  
  test1(id)
  {
      this.setState({
          loading_gif:true,
      });
      $(window).scrollTop(0);
      localStorage.setItem('d_type',this.props.params.DType);
      localStorage.setItem('w_r_p_deals',"/web/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType);
      this.getTypes();
      var data1={from: 'desktop_web',type:id};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getbrands_categoires',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
            this.setState({
                fulldata: data,
                feedbrands:data.brands,
                feedcat:data.categories,
                feed_sub_cat:data.categories[1].sub,
                dtype: this.props.params.Dtype,
                loading_gif:false,
            });
          }.bind(this),
          error: function(err)
          {
          }
      })
      var data3={from: 'desktop_web',type:id,limit:20};
      var data4=JSON.stringify(data3);
      $.ajax({
          method:'POST',
          url:baseUrl+'getPoductDeals',
          dataType:'json',
          data:{req:data4},
          success: function(data1)
          {
              this.setState({
                feedsList:data1.result,
                offer: data1,
                loading:true,
                title:data1.cat_name,
                selected:data1.cat_name,
                desc:data1.cat_desc,
                seo_desc:'Browse best deals,Aquaculture products from '+data1.cat_name+' in AquaDeals.Contact customer care for any queries.',
                loading_gif:false,

                total_deals:data1.tot_deals,
              });
              document.title =this.state.title+ " - Products  | AquaDeals";
              document.getElementsByTagName("META")[2].content=this.state.seo_desc;             
          }.bind(this),
          error: function(err)
          {
            this.setState({
              loading_gif:false,
            });
          }
      });
  }
  setFilter(filter,id,type)
  {
    this.setState({ selected: filter,tid:id,type:type});
  }
  isActive(value)
  {
    if(value)
    { 
      return 'li '+((value === this.state.selected) ?'active':'');
    }
  }
  
  render(){
      var brands = this.state.feedbrands.map(function(brand,index){
          return(
            <li key={brand.id} id={"brand_"+brand.id} className={this.isActive(brand.category_name)} onClick={this.setFilter.bind(this, brand.category_name,brand.id,brand.type)}>
              <Link onClick={()=>{this.test(brand.type,brand.id,brand.dtype)}} to={this.props.params.Bid ? "/web/pdeals/brands/"+brand.url_name+"/"+brand.id : "/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.id+"/"+brand.type+"/"+brand.dtype }>
                  <span>{brand.category_name}</span>
              </Link>
            </li>
                );
          }.bind(this));
    
      var cat_filter = this.state.sortList.map(function(item,index){
         return(
             <option key={item.id} id={item.id}  value={item.name}>{item.name}</option>
          ); 
      });

      // var categories = this.state.categories.map(function(brandcat,index){
      //    return(
      //       <li key={index}>
      //          <Link to={"/web/pdeals/brands/"+brandcat.url_name+"/"+brandcat.id} /*onClick={() =>{this.test('Pcategory',brandcat.id,0)}}*/>
      //              <span>{brandcat.name}</span>
      //          </Link>
      //       </li> 
      //     );
      // });
    
// '/web/pdeals/brands/'+this.props.params.BrandName+'/'+this.props.params.Bid
    // if(!this.props.params.Bid this.props.location.pathname !== this.state.route)
    // {          
      var cate= this.state.feedcat.map(function(cat,index){
            
            if(cat.sub.length > 0)
            {
            var subs_cat = cat.sub.map(function(sub_cat,index){
                  return(
                      <li key={sub_cat.id} id={"sub_cat_"+sub_cat.id} className={"sub_cat_li "+this.isActive(sub_cat.category_name)} onClick={this.setFilter.bind(this, sub_cat.category_name,sub_cat.id,sub_cat.type)} >
                      {/*<li key={sub_cat.id} id={"sub_cat_"+sub_cat.id} className={"sub_cat_li "+this.isActive(sub_cat.category_name)} onClick={this.setFilter.bind(this, sub_cat.category_name)} >*/}
                        <Link onClick={()=>{this.test(sub_cat.type,sub_cat.id,sub_cat.dtype)}} to={"/web/pdeals/"+sub_cat.url_dtype_name+"/"+sub_cat.url_name+"/"+sub_cat.id+"/"+sub_cat.type+"/"+sub_cat.dtype}>
                            <span>{sub_cat.category_name}</span> 
                        </Link>
                      </li>
                  );
              }.bind(this));
              return(
                    <li key={cat.id} id={"cat_"+cat.id} >
                    {/*<li key={cat.id} id={"cat_"+cat.id} className={this.isActive(cat.category_name)} onClick={this.setFilter.bind(this, cat.category_name)}>*/}
                        <Link>
                             <span>
                            {cat.category_name}
                            </span>
                        </Link>
                        {subs_cat}
                    </li>);
               }
               else
               {
                return(
                    <li key={cat.id} id={"cat_"+cat.id} className={this.isActive(cat.category_name)} onClick={this.setFilter.bind(this, cat.category_name,cat.id,cat.type)}>
                        <Link onClick={()=>{this.test(cat.type,cat.id,cat.dtype)}} to={"/web/pdeals/"+cat.url_dtype_name+"/"+cat.url_name+"/"+cat.id+"/"+cat.type+"/"+cat.dtype}>
                             <span>
                               {cat.category_name}
                            </span>
                        </Link>
                    </li>);
              }
            }.bind(this));
       // }
       // else{
       //   cate ='';
       // } 
        var products='';
        if(this.state.feedsList.length >0)
        {
            products = this.state.feedsList.map((product,index) => (<PDeal key={product.id} data={product} /> ));
        }
                        
        return(
        <div className="web_Deals web_pdeals_page">        
          {this.state.loading ? 
            <div className="lgt_gry">
                <WebHeaderInner cart_updated_count={this.state.cart_count} />
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                {/* <!-- content start --> */}
               <section className="container pro_lst_cntnt">
                  <div className="clr">&nbsp;</div>
                  <h1 className="page_title">{this.state.h1_desc}</h1>
                  {/*<!-- Breadcrumbs start --> */}
                  <div className="container"> 
                     <Breadcrumb className="webpdeals_breadcrmb">
                       <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
                       <Breadcrumb.Item active>{this.state.selected}</Breadcrumb.Item>
                     </Breadcrumb>
                 </div> 
                 {/* <!-- Breadcrumbs end --> */}
                  <div className="clr"></div>
                 {/* <!-- total products block start --> */}
                 <div className="tot_pro">
                    <div className="row" style={{marginRight:'0 !important'}}>
                     {/*<!-- filters start --> */}
                     <div className="col-md-3 col-sm-3">
                        <div className="filtrs_blk">
                           <h3>Categories</h3>
                             <ul>
                               {this.state.catloading_gif ? <i className="web_catloading_gif"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> : <i className="web_catloading_gif"></i>}
                               {cate}
                              </ul>
                              {brands.length > 0 ? <h3>Brands</h3>: ''}
                              <ul className={brands.length > 10 ? 'flt_scrl' : 'no_scrl'}>
                                {brands}
                              </ul>
                        </div>
                     </div>
                     <div className="pro_sec col-md-9 col-sm-9">
                       {/*  <!-- products section header start --> */}
                          <div className="pro_sec_hdr">
                             <h3>{this.state.selected}<span>({this.state.total_deals} Items)</span></h3>
                            <div className="pro_slt_fltr">
                              <select onChange={this.getSelectedCatSort} > 
                                 <option>Select</option>
                                 {cat_filter}
                              </select>
                            </div>
                          </div>
                        {/*  <!-- products section header end --> */}
                         {/* <!-- products blocks start --> */}
                            <div className="row itm_lst">
                                    {this.state.loading_gif ? <i className="web_loading_gif"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> : <i className="web_loading_gif"></i>}
                                      {/*{products ? products : <div>{this.state.lod ? <div className="seed_no_data">No Deals Available</div> : <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:15+'%'}}><img src={baseAssets+'images/web_imgs/ajax-loader.gif'} alt="AquaDeals" role="presentation" /></div> }</div> }*/}
                                    <InfiniteScroll
                                        pullDownToRefresh
                                        pullDownToRefreshContent={
                                          <h3 style={{textAlign: 'center'}}>&#8595;</h3>
                                        }
                                        releaseToRefreshContent={
                                          <h3 style={{textAlign: 'center'}}>&#8593;</h3>
                                        }
                                        refreshFunction={this.refresh}
                                        next={this.fetchData}
                                        hasMore={true}
                                        scrollThreshold={0.5}
                                        loader={<h4></h4>}
                                        endMessage={
                                          <p style={{textAlign: 'center'}}>
                                            <b></b>
                                          </p>
                                        }>
                                        {products}
                                      </InfiniteScroll>
                                  {this.state.nodata_status ? <div className="seed_no_data">No Deals Available</div>: ''}
                            </div>
                                        {/*{this.state.loadmore_status === 1  ? <div className="web_loadmore_button" onClick={()=>{this.setState({ loadmore_number : this.state.loadmore_number+1 }); this.loadMoreDeals(this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType)}}><i className="glyphicon glyphicon-circle-arrow-down"></i>Load More Deals</div> : ''} */}
                            </div>
                        </div>
                     </div>
                 </section>
                 <WebFooter />   
               </div>
             :
             <div className="loading_sym" style={{width:'100%',textAlign:'center',marginTop:'20%'}}><img src={baseAssets+'images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /></div>}</div>
        );
    }
}


















/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Feed/Web_pdeals.js
 **/